// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3H1Le","label":"Category_label__3B5KN","content":"Category_content__EgByR","header":"Category_header__m0x6b","location":"Category_location__1iLAm"};